import { FC, JSX } from 'react';
import { Link } from 'react-router-dom';
import { Box, Dialog, Button, DialogTitle, DialogActions, DialogContent, Typography } from '@mui/material';
// data
import { handleLogout } from 'lib/helper';
import { useAuthContext } from 'contexts/AuthContext';
import {
  TERMS_AND_CONDITIONS_LINK,
  PRIVACY_POLICY_LINK,
  ACCEPT_TEXT,
  DECLINE_TEXT,
  TERMS_OF_USE_TEXT,
  ACKNOWLEDGE_THE_TEXT,
  PRIVACY_POLICY_TEXT,
  TO_START_USING_YOUR_ACCOUNT_TEXT,
  PLEASE_AGREE_TO_THE_TEXT,
} from 'constants/index';

const ConsentForm: FC = (): JSX.Element => {
  const { setIsAcceptConsent } = useAuthContext();

  const onDecline = () => {
    handleLogout();
  };

  const onAccept = () => {
    setIsAcceptConsent(true);
  };

  return (
    <Dialog open fullWidth maxWidth="md">
      <DialogTitle>{`${TERMS_OF_USE_TEXT} & ${PRIVACY_POLICY_TEXT}`}</DialogTitle>
      <DialogContent>
        <Typography fontWeight={500} variant="body2" color="white" mt={1}>
          {PLEASE_AGREE_TO_THE_TEXT}
          <Typography
            component={Link}
            variant="body2"
            to={TERMS_AND_CONDITIONS_LINK}
            color="primary"
            target="_blank">
            {` ${TERMS_OF_USE_TEXT} `}
          </Typography>
          {ACKNOWLEDGE_THE_TEXT}
          <Typography
            component={Link}
            variant="body2"
            to={PRIVACY_POLICY_LINK}
            color="primary"
            target="_blank">
            {` ${PRIVACY_POLICY_TEXT} `}
          </Typography>
          {TO_START_USING_YOUR_ACCOUNT_TEXT}
        </Typography>
      </DialogContent>
      <DialogActions>
        <Box width={'100%'} display={'flex'} justifyContent={'space-between'} flexWrap={'wrap'}>
          <Button variant="outlined" color="error" onClick={onDecline}>
            {DECLINE_TEXT}
          </Button>
          <Button variant="contained" onClick={onAccept}>
            {ACCEPT_TEXT}
          </Button>
        </Box>
      </DialogActions>
    </Dialog>
  );
};

export default ConsentForm;
